import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TextField, IconButton, Icon, Chip,
} from '@material-ui/core';

const styles = {
  chip: {
    marginRight: 5,
    marginBottom: 5,
  },
  iconButton: {
    padding: 0,
  },
};

class EmailListInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textInput: '',
      error: false,
    };
  }

  handleTextInput = (value) => {
    this.setState({ textInput: value, error: false });
  }

  handleAddValue = () => {
    const { value, onChange, validateEmail } = this.props;
    const { textInput } = this.state;

    const isValidEmail = validateEmail(textInput);

    if (textInput && isValidEmail) {
      onChange(value.concat(textInput));
      this.setState({ textInput: '' });
    } else {
      this.setState({ error: textInput && !isValidEmail });
    }
  }

  handleKeyDown = (key) => {
    if (key === 'Enter') {
      this.handleAddValue();
    }
  }

  renderValues() {
    const { value, onChange } = this.props;

    return value.map((v, i) => (
      <Chip
        key={v}
        label={v}
        style={styles.chip}
        onDelete={() => onChange(value.filter((_, j) => j !== i))}
      />
    ));
  }

  render() {
    const { textInput, error } = this.state;
    return (
      <div>
        {this.renderValues()}

        <div style={{ display: 'flex' }}>
          <TextField
            style={{ flexGrow: 1 }}
            value={textInput}
            onChange={e => this.handleTextInput(e.target.value)}
            onKeyDown={e => this.handleKeyDown(e.key)}
            onBlur={this.handleAddValue}
            error={error}
            helperText={error && 'Bitte geben Sie eine gültige E-Mail Adresse ein.'}
          />
          <IconButton style={styles.iconButton} onClick={this.handleAddValue}>
            <Icon>add</Icon>
          </IconButton>
        </div>
      </div>
    );
  }
}

EmailListInput.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  validateEmail: PropTypes.func.isRequired,
};

EmailListInput.defaultProps = {
  value: [],
};

export default EmailListInput;
